<template>
	<v-flex xs12>
		<v-card>
			<v-card-title>
				<v-flex xs3>
					<v-toolbar-title>Booking</v-toolbar-title>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						v-model="search"
						append-icon="search"
						label="Search"
						single-line
						hide-details
					></v-text-field>
				</v-flex>
				<!-- <v-flex class="text-right" xs3>
          <v-btn to="/legaldocuments/add" dark color="indigo">
            <v-icon dark>add_circle</v-icon>New
          </v-btn>
        </v-flex>-->
			</v-card-title>
			<v-data-table
				:headers="headers"
				:items="body"
				:search="search"
				:options.sync="options"
				:server-items-length="total"
				:loading="loading"
				:sort-by="['createdDate']"
				:sort-desc="[true]"
			>
				<template v-slot:item.name="{ item }">
					<a :href="'/booking/' + item.id">{{ item.name }}</a>
				</template>
				<template v-slot:no-data>
					<v-alert :value="true">No results found.</v-alert>
				</template>
			</v-data-table>
		</v-card>
	</v-flex>
</template>

<script>
	import commonservice from "../../shared/common.service";
	export default {
		data() {
			return {
				search: "",
				loading: false,
				options: {},
				total: 0,
				headers: [
					{ text: "Name", value: "name" },
					{ text: "Title", value: "title" },
					{ text: "No Of Person", value: "noOfPerson" },
					{ text: "Created Date", value: "createdDate" },
					{ text: "Status", value: "status" },
				],
				body: [],
			};
		},
		watch: {
			options: {
				handler() {
					this.getData();
				},
				deep: true,
			},
			search() {
				this.getData();
			},
		},
		methods: {
			editItem(item) {
				this.$router.push("/booking/edit/" + item.id);
			},
			deleteItem(item) {
				var title = "Are you sure, you want to delete booking?";
				commonservice.showDialog("Delete", title).then((result) => {
					if (result.value) {
						this.$store
							.dispatch("booking/deleteBooking", { id: item.id })
							.then(() => {
								this.getData();
								commonservice.showSuccessMessage(
									"Booking deleted successfully"
								);
							});
					}
				});
			},
			getData() {
				this.$store
					.dispatch("booking/loadBooking", {
						pagination: this.options,
						search: this.search,
					})
					.then((response) => {
						this.loading = false;
						this.body = response.data.data;
						this.total = response.data.total;
					})
					.catch(() => {
						this.loading = false;
					});
			},
		},
	};
</script>
